module.exports = __webpack_public_path__ + "img/GAME_MAHJONGSOLITAIRE1.742b8c3b.jpg";